import { render, staticRenderFns } from "./TermsGate.vue?vue&type=template&id=0b55f510"
import script from "./TermsGate.vue?vue&type=script&lang=js"
export * from "./TermsGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports